import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { CoreIdentity } from "./components/CoreIdentity";
import { About } from "./components/About";
import { VisionMission } from "./components/VisionMission";
import { Structure } from "./components/Structure";
import { MainPrograms } from "./components/MainPrograms";
import { SupportingPrograms } from "./components/SupportingPrograms";
import { FormalEducation } from "./components/FormalEducation";
import { Facilities } from "./components/Facilities";
import { Gallery } from "./components/Gallery";
import { Registration } from "./components/Registration";
import { MainCTA } from "./components/MainCTA";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";
import { MobileStickyCTA } from "./components/MobileStickyCTA";

function App() {
    useEffect(() => {
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduced) return undefined;
        const lenis = new Lenis({
            duration: 1.1,
            anchors: { offset: -88, duration: 1.2 },
        });
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="min-h-screen bg-bh-offwhite">
            <Header />
            <main>
                <Hero />
                <Marquee />
                <CoreIdentity />
                <About />
                <VisionMission />
                <Structure />
                <MainPrograms />
                <SupportingPrograms />
                <FormalEducation />
                <Facilities />
                <Gallery />
                <Registration />
                <MainCTA />
                <Contact />
            </main>
            <Footer />
            <div aria-hidden="true" className="h-[60px] lg:hidden bg-bh-deep" />
            <FloatingWhatsApp />
            <MobileStickyCTA />
        </div>
    );
}

export default App;
